import "./App.css";

import AboveTheFold from "./components/AboveTheFold";
import ContactPage from "./components/ContactPage";
import CoursesBrief from "./components/CoursesBrief";
import ExpandOnFirstPage from "./components/ExpandOnFirstPage";
import Footer from "./components/Footer";
import Fun from "./components/Fun";
import Header from "./components/Header.jsx";
import LandingPage from "./components/LandingPage";
import LiskovWho from "./components/LiskovWho";
import Testimonials from "./components/Testimonials";
import ClassroomImage from "./components/ClassroomImage";
import CoffeeShopImageComponent from "./components/CoffeeShopImage";
import WorkplaceImageComponent from "./components/WorkplaceImage";
// import WhatCoding from './components/WhatCoding';
// import WhyLiskov from './components/WhyLiskov';
// import ContactUs from "./components/ContactUs";
// import DetailsBrief from "./components/DetailsBrief";
// import HomePageExpanded from "./components/HomePageExpanded";
// import ImageGroupThree from "./components/ImageGroupThree";
// import ImageOne from "./components/ImageOne";
// import ImageTwo from "./components/ImageTwo";
// import Omicron from "./components/Omicron";
// import Overview from "./components/Overview";
// import SuperBriefHomePage from "./components/SuperBriefHomePage";

function App() {
	return (
		<div className="app" id="home-town">
			<Header />
			<main>
				<LandingPage />
        		<ClassroomImage />
				<AboveTheFold />
				<CoursesBrief />
				<ExpandOnFirstPage />
        		<CoffeeShopImageComponent />
				<ContactPage />
				<LiskovWho />
        		<WorkplaceImageComponent />
				<Testimonials />
				<Fun />
			</main>
			<Footer />
		</div>
	);
}

export default App;
